import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Regex } from "../../types/Regex";

@Component({
  selector: "app-prefix-pr7",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-pr7.component.html",
  styleUrl: "./prefix-pr7.component.less",
})
export class PrefixPr7Component extends PrefixComponent<string> {
  public regex: Regex;
  public commas: number;

  public constructor() {
    super({
      defaultValue: "0",
      updateOn: "blur",
    });
    this.required = true;
    this.regex = "PR7";
    this.commas = 3;
    this.characters = ALLOWED_CHARACTERS["pr7"];
  }
}
